import React from 'react';

import { useModalObject } from '@front/common/src/hooks/use-modal';

import { translate } from '@front/i18n';

import TextButton from '@front/web-ui/src/components/button/text-button';
import Text from '@front/web-ui/src/components/base-text/variants/text';
import Alert from '@front/web-ui/src/components/alert/alert';

import TaxModal from './tax-modal';

const t = translate('basket.cleaning.services.tax.alert');

const AlertContent = ({ open }: { open: () => void }) => (
  <div>
    <Text.SM>{`${t('.text')} `}</Text.SM>
    <TextButton size='sm' onClick={open}>
      {t('.text_button')}
    </TextButton>
    <Text.SM>{' 🤩'}</Text.SM>
  </div>
);

const TaxCreditAlert = () => {
  const { isOpen, open, close } = useModalObject();

  return (
    <>
      <TaxModal onClose={close} isOpen={isOpen} />
      <Alert type='info' content={<AlertContent open={open} />} />
    </>
  );
};

export default TaxCreditAlert;
